<template>
  <div>
    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push(`/${module}`)"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-6">
        <q-btn  style="float: right"
          class="capitalize ctrl-button right q-ml-md"
          :color="disable ? 'grey-5' : 'ctrl-turquoise'"
          :disable="disable"
          :label="`${$store.state.stringsStore.strings.action.save}`"
          @click="saveChanges()"
          icon-right="save"
        />
        <q-btn v-if="data.id"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          align="right"
          @click="deleteErrorCode()"
        />
      </div>
    </div>

    <!-- Columns -->
    <div class="row gutter-sm q-mb-lg">
      <!-- Left -->
      <div class="col-md-6 col-sm-12 col-xs-12 q-pa-sm">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">
              {{ getString('errorcode.code.header') }}
            </p>

            <div class="card-block">
              <div class="row">
                <q-input
                  type="text"
                  class="full-width q-mb-md"
                  float-label="Code"
                  v-model="data.code"
                />
              </div>
              <div class="row">
                <q-input
                  type="textarea"
                  class="full-width q-mb-md"
                  :float-label="getString('description')"
                  v-model="data.description"
                />
              </div>
              <div class="row">
                <q-input
                  type="textarea"
                  class="full-width q-mb-md"
                  :float-label="getString('errorcode.field.control')"
                  v-model="data.control"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- Right -->
      <div class="col-md-6 col-sm-12 col-xs-12 q-pl-sm">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">
                Unit
            </p>

            <div class="card-block">
              <div class="row">
                <q-select
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('errorcode.source.header')"
                  v-model="data.source"
                  :options="sourceOptions"
                />
              </div>
              <div class="row q-mt-md">

                <div class="col">
                  <q-field class="q-mb-md">
                    <q-toggle
                      :disable="false"
                      v-model="data.standard"
                      color="secondary">
                      <span class="q-ml-md">
                        {{ getString('errorcode.unit.standard') }}
                      </span>
                    </q-toggle>
                  </q-field>
                </div>

                <div class="col">
                  <q-field class="q-mb-md">
                    <q-toggle
                      :disable="false"
                      v-model="data.inverter"
                      color="secondary">
                      <span class="q-ml-md">
                        {{ getString('errorcode.unit.inverter') }}
                      </span>
                    </q-toggle>
                  </q-field>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
import fetchDetail from '@/mixins/detailViews/fetchDetail';
import getString from '@/helpers/GetStrings';
import saveChanges from '@/mixins/detailViews/saveChanges';
import common from '../common';

export default {
  mixins: [
    common,
    fetchDetail,
    saveChanges,
  ],
  data() {
    return {
      disable: false,
      sourceOptions: [
        {
          label: this.getString('errorcode.source.service'),
          value: 'service',
        },
        {
          label: this.getString('errorcode.source.internal'),
          value: 'internal',
        },
        {
          label: this.getString('errorcode.source.external'),
          value: 'external',
        },
        {
          label: this.getString('errorcode.source.combination'),
          value: 'combination',
        },
      ],
      data: {
        code: '',
        description: '',
        control: '',
        source: '',
        standard: false,
        inverter: false,
      },
    };
  },

  methods: {
    getString,

    requestParams() {
      return {
        code: this.data.code,
        description: this.data.description,
        control: this.data.control,
        source: this.data.source,
        standard: this.data.standard ? 1 : 0,
        inverter: this.data.inverter ? 1 : 0,
      };
    },

    deleteErrorCode() {
      // Dialog
      this.$q.dialog({
        title: '',
        message: this.getString('module.library.delete.title.single'),
        ok: this.$store.state.stringsStore.strings.dialog.confirm.ok,
        cancel: this.$store.state.stringsStore.strings.dialog.confirm.cancel,
      }).then(() => {
        // delete call
        this.axios.delete(`${this.endpoint}/${this.data.id}`)
          .then(() => {
            // Refresh data to see the result
            this.$q.notify({
              message: this.getString('module.errorcode.edit.delete.single'),
              position: 'top-right',
              timeout: 1000,
              color: 'positive',
            });
            this.$router.push('/errorcode');
          })
          .catch((error) => {
            // Error
            console.warn(error);
          });
      }).catch(() => {
        console.warn('Not removed');
      });
    },
  },

  mounted() {
  },
};
</script>

<style lang="stylus" scoped>

</style>
